import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { FeatureList } from '.';
import { Button, Column, Box, BoxName, BoxDivider, LinkBack, BoxWarning, BoxTitle, BoxTitleSmall } from './styled';
import { createPrice, getProductFeatures, Period } from '../helpers/product';
import { redirectWithQueryParams, PagePath } from '../helpers/util';
import { appActions } from '../store/ducks/app';

interface OwnProps {
  intl?: any;
}

const mapStateToProps = (state: any) => ({
  locationQuery: state.router.location.query,
  groupType: state.appData.general.selectedGroupType,
  period: state.appData.general.selectedPeriod,
  products: state.appData.general.products,
  loading: state.appData.loading,
  language: state.appData.language,
  currency: state.appData.currency,
});

type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  switchPeriod: () => void;
}

type Props = OwnProps & StateProps & DispatchProps;

class FeatureBox extends React.Component<Props> {
  render() {
    if (!this.props.groupType) {
      return null;
    }
    const isMonthly:boolean = this.props.period === Period.MONTHLY;

    return (
      <Box>
        <BoxName>
          <>
            <LinkBack onClick={() => redirectWithQueryParams(PagePath.plans, this.props.locationQuery)} className="material-icons" >
              arrow_back
            </LinkBack>
          </>
          <FormattedMessage id={this.props.groupType} />
        </BoxName>
        <BoxDivider />
        <BoxTitle>
          {
            <>
              { `${createPrice(this.props.products, this.props.groupType, this.props.period, this.props.currency, isMonthly)}${isMonthly ? '/' : ' '}` }
              <FormattedMessage id={isMonthly ? 'month' : 'billed_yearly'} />
            </>
          }
        </BoxTitle>
        <Column>
          <BoxTitleSmall>
            <>
              { `${!isMonthly ? `(${this.props.intl.formatMessage({ id: 'thats' })} ${createPrice(this.props.products, this.props.groupType, this.props.period, this.props.currency, !isMonthly)}/` : ''}` }
              { `${!isMonthly ? `${this.props.intl.formatMessage({ id: 'month' })}) *` : `${this.props.intl.formatMessage({ id: 'billed_monthly' })}`}` }
            </>
          </BoxTitleSmall>
        </Column>
        <Column>
          <FeatureList features={getProductFeatures(this.props.groupType)} />
        </Column>
        <Button onClick={this.props.switchPeriod} disabled={this.props.loading}>
          <FormattedMessage
            id={this.props.period === Period.MONTHLY ? `switch_to_${Period.YEARLY}_and_save_${this.props.groupType}` : `switch_to_${Period.MONTHLY}`} />
          { this.props.loading && <i className="fa fa-spinner fa-pulse fa-fw" style={{ marginTop: '3px' }} /> }
        </Button>
        {
          this.props.period === Period.YEARLY && (
            <BoxWarning>
              <FormattedMessage
                id="warning_charged"
                values={
                  { br: <br />,
                    $1: `${createPrice(this.props.products, this.props.groupType, Period.YEARLY, this.props.currency)}` }
                }
              />
            </BoxWarning>
          )
        }
      </Box>
    );
  }
}

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, appActions)(injectIntl(injectedIntl));

export function injectedIntl(props: Props) {
  return <FeatureBox {...props} />;
}
